import { injectable, injectFromBase } from 'inversify'
import DomainBaseService from '@/services/domain/domainBaseService'
import { DomainSettings } from '@/decorators/domainDecorators'
import Timezone from '@/data/models/domain/Timezone'
import type TimezoneRepository from '@/data/repositories/domain/timezoneRepository'
import TmLogicError from '@/core/error/tmLogicError'

@DomainSettings({
  model: Timezone,
})
@injectable()
@injectFromBase()
export default class TimezoneService extends DomainBaseService<TimezoneRepository> {
  public getEntityByTimezone(timezone: Timezone['timezone']) {
    return this.getDomainRepository().query().where('timezone', timezone).first()
  }

  public getEntityByTimezoneOrFail(timezone: Timezone['timezone']) {
    const t = this.getEntityByTimezone(timezone)
    if (!t) {
      throw new TmLogicError(`Not found Timezone with name "${timezone}"`)
    }
    return t
  }
}
